/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import type { CosmosVariableRichText } from "@components/elements/atoms/text";
import type { FaqItemElementFragment, FaqTabElementFragment } from "@cosmos/hygraph-schema";
import { cleanHashId, getFaqId, getShortId } from "./id.utils";

export type FAQHashFields = {
	fallbackLinkId: string;
	anchorLinkId?: string;
};

export type FAQItem = {
	id: string;
	question: CosmosVariableRichText;
	answer: CosmosVariableRichText;
	defaultOpen?: boolean;
} & FAQHashFields;

export type FAQTab = {
	id: string;
	title?: null | string;
	items: FAQItem[];
} & FAQHashFields;

export type FAQProps = {
	id?: string;
	items?: FAQItem[];
	title?: string;
	titleVariant?: "headingXL" | "headingLG";
};

export const hasFAQHash = (item: FAQHashFields, hash: string): boolean =>
	(!!item?.anchorLinkId && item?.anchorLinkId === hash) || (!!item?.fallbackLinkId && item?.fallbackLinkId === hash);

export const cleanFAQItem = (item: FaqItemElementFragment): FAQItem => ({
	id: item?.id,
	anchorLinkId: cleanHashId(item?.anchorLinkId || "") || undefined,
	fallbackLinkId: getFaqId(getShortId(item?.id)),
	question: {
		...item?.question,
	},
	answer: {
		...item?.answer,
	},
	defaultOpen: item?.defaultOpen ? true : undefined,
});

export const cleanFAQTab = (tab: FaqTabElementFragment): FAQTab => ({
	id: tab?.id,
	title: tab?.title,
	anchorLinkId: cleanHashId(tab?.anchorLinkId || "") || undefined,
	fallbackLinkId: getFaqId(getShortId(tab?.id)),
	items: tab?.items?.map(cleanFAQItem),
});
